import type { ChannelId } from '@/interfaces/service/appstore/appstore.interface';
import { convertQueryParam } from '@/utils/path.util';
import { SEND_OPT_URL, SEND_OPT_URL_SIGN_UP, TOKEN_REFRESH_URL, USER_LOGIN_URL } from '@/libs/constants/url';

export const ROUTES = {
  getMainDashboard: (appStoreId?: number) => {
    return `/dashboard${appStoreId ? '/' + appStoreId : ''}`;
  },
  getLogin: (redirectUrl?: string) => {
    return `/login${redirectUrl ? `?redirectUrl=${redirectUrl}` : ''}`;
  },
  getSignUp: (redirectUrl?: string) => {
    return `/auth/signup${redirectUrl ? `?redirectUrl=${redirectUrl}` : ''}`;
  },
  getRedirectMiddleware: (params?: { type: 'UNAUTHENTICATED' | 'TOKEN_EXPIRED' | undefined; message?: string }) => {
    return `/redirect${params?.type || params?.message ? convertQueryParam(params) : ''}`;
  },
  getOrganization: () => {
    return `/organization`;
  }
};

export const REVIEW_ROUTES = {
  getStoreDashboard: (appStoreId: number) => {
    return `/stores/${appStoreId}/dashboard`;
  },
  getReviews: (appStoreId: number) => {
    return `/stores/${appStoreId}/reviews`;
  },
  getSearch: (searchWord?: string) => {
    return `/search${searchWord ? '?word=' + searchWord : ''}`;
  },
  getSearchWaiting: (appStoreId: number) => {
    return `/search/waiting/${appStoreId}`;
  },
  getInsertAccountInfo: (appStoreId: number, channelId: ChannelId) => {
    return `/stores/${appStoreId}/account/info${convertQueryParam({ appStoreId, channelId })}`;
  },
  getAccountAuth: (appStoreId: number, channelId: ChannelId, type: 'sms' | 'tms') => {
    return `/stores/${appStoreId}/account/auth${convertQueryParam({ appStoreId, channelId, type })}`;
  },
  getSettingsPage: () => '/review/settings'
};

export const BASE_URL = 'https://revieworks.com';

/** 검색엔진 노출용 공개 경로 (메인 + 랜딩 + stores/-1/dashboard) */
export const PUBLIC_SEO_PATHS = ['/', '/medicontents/landing', '/enterprise/landing', '/review-booster/landing', '/stores/-1/dashboard'] as const;

/** robots.txt에서 차단할 경로 (인증/병원 전용) */
export const ROBOTS_DISALLOW_PATHS = [
  '/dashboard',
  '/dashboard/',
  '/stores',
  '/auth',
  '/login',
  '/organization',
  '/invitation',
  '/redirect',
  '/api',
  '/review-booster',
  '/review-booster/',
  '/review/'
] as const;
export const USER_SIGNUP_URL = '/api/v1/auth/sign-up';
export const GET_INVITATION_INFOS_PATTERN = '/api/v1/organizations/${organizationId}/invitations/${invitationToken}';
export const ACCEPT_INVITATIONS_PATTERN = '/api/v1/organizations/${organizationId}/invitations/${invitationToken}/accept';

export const convertPathVariable = (pattern: string, variables: Record<string, string>) => {
  const keys = Object.keys(variables);

  let path = pattern;

  keys.forEach((key: string) => {
    path = path.replace(`\$\{${key}\}`, variables[key]);
  });

  return path;
};

// ⚠️ **실제로 호출되는 경로**를 넣어야 한다. 상수 이름이 그럴듯하다고 맞는 게 아니다.
// `sendOtp()` 는 `SEND_OPT_URL` 이 아니라 `SEND_OPT_URL_SIGN_UP`(`/api/v1/otp/send`) 으로 나가는데
// 여기엔 앞의 것만 있어서, OTP 요청이 낡은 `Authorization` 을 달고 나가고 있었다.
// (구 SecurityConfig 도 `POST /api/v1/otp/send` 를 permitAll 로 열어 둔다 — 서버 쪽도 토큰 불필요)
// 둘 다 남긴다: 어느 쪽이 죽은 상수인지는 이 변경의 범위가 아니다.
export const NO_TOKEN_APIS = [USER_SIGNUP_URL, USER_LOGIN_URL, SEND_OPT_URL, SEND_OPT_URL_SIGN_UP, TOKEN_REFRESH_URL];

export const NO_TOKEN_API_PATTERNS = [
  convertPathVariable(GET_INVITATION_INFOS_PATTERN, {
    organizationId: '*',
    invitationToken: '*'
  }),
  convertPathVariable(ACCEPT_INVITATIONS_PATTERN, {
    organizationId: '*',
    invitationToken: '*'
  })
];
